<style lang="scss" scoped>
.workwechat {
  .custom_alert {
    margin-bottom: 20px;
  }
  .btn {
    margin-left: 20px;
  }

  .el-input {
    input {
      color: #595959 !important;
    }
    .el-input__inner {
      color: #595959 !important;
    }
  }
  .el-divider {
    width: 80%;
    margin-left: 5%;
  }
}
</style>

<template>
  <!-- 企业微信授权配置 -->
  <div class="workwechat">
    <!-- <div class="wechat-top">
      <div>
        <div class="title">企业微信授权配置</div>
        <div class="tips"></div>
      </div>
    </div> -->

    <SpGlobalAlertWarning
      info=" 客户联系回调用于接收企业成员发送的普通消息以及菜单操作、外部联系人变更回调等事件信息；通讯录回调用于同步企业成员的信息变更。"
      class-name="custom_alert"
    />    
    <SpCardContent :title="`企业信息授权`">
      <el-form
        ref="form"
        :model="form"
        label-width="200px"
      >
        <el-form-item label="企业ID">
          <el-input
            v-model="form.corpid"
            style="width: 600px"
          />

          <div class="tips">
            企业ID，获取方式参考<a
              href="https://work.weixin.qq.com/api/doc#90000/90135/90665/corpid"
              target="_blank"
            >术语说明-corpid</a>
          </div>
        </el-form-item>
        <!--
        <el-form-item label="小程序appid">
          <el-input
            v-model="form.app.appid"
            style="width: 600px"
          />
        </el-form-item>
         <el-form-item label="小程序Secret">
          <el-input
            v-model="form.app.secret"
            style="width: 600px"
          />
          <br>
          <div class="tips">
            企业微信的小程序凭证密钥，获取方式参考<a
              href="https://work.weixin.qq.com/api/doc#90000/90135/90665/secret"
              target="_blank"
            >术语说明-secret</a>
          </div>
        </el-form-item>
        <el-form-item label="小程序AgentId">
          <el-input
            v-model="form.app.agent_id"
            style="width: 600px"
          />

          <div class="tips">
            企业微信的小程序agent_id，获取方式参考<a
              href="https://work.weixin.qq.com/api/doc#90000/90135/90665/agentid"
              target="_blank"
            >术语说明-agent_id</a>
          </div>
        </el-form-item> -->
      </el-form>
    </SpCardContent>

    <SpCardContent :title="`客户联系API授权设置`">
      <el-form
        ref="form"
        :model="form"
        label-width="200px"
      >
        <el-form-item label="AgentId">
          <el-input
            v-model="form.external_contact.agent_id"
            style="width: 600px"
          />
        </el-form-item>
        <el-form-item label="Secret">
          <el-input
            v-model="form.external_contact.secret"
            style="width: 600px"
          />
          <div class="tips">
            获取路径：<br>
            1. 在
            <a
              href="https://work.weixin.qq.com/wework_admin/loginpage_wx?from=myhome"
              target="_blank"
            >企业微信管理后台</a>
            -「应用管理」-应用-下方的「自建应用」中找到云店小程序。<br>
            2.
            点击进入应用详情页，点击「Secret」后的「查看」按钮。该Secret会发送到当前登录的管理员账号的企业微信内，管理员在企业微信内复制获取，将获取到的Secret粘贴至此处。
          </div>
        </el-form-item>

        <el-divider style="width: 80%; margin-left: 5%" />
        <el-form-item>
          <div style="margin-left: -140px">
            接收事件服务器配置
          </div>
          <div
            style=""
            class="tips"
          >
            设置路径：<br>
            1. 在
            <a
              href="https://work.weixin.qq.com/wework_admin/loginpage_wx?from=myhome"
              target="_blank"
            >企业微信管理后台</a>
            -「应用管理」-应用-下方的「自建应用」中找到云店小程序。<br>
            2. 点击进入应用详情页，找到「功能」中的「接收消息」，点击「设置 API
            接收」，依次复制下方内容填写至对应输入框中。
          </div>
        </el-form-item>
        <el-form-item label="URL">
          <div>
            <el-input
              v-model="URL"
              disabled
              style="width: 600px"
            />
            <el-button
              type="primary"
              class="btn"
              style="height: 36px"
              @click="onCopy(URL)"
            >
              复制
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="Token">
          <div>
            <el-input
              v-model="form.external_contact.token"
              disabled
              style="width: 600px"
            />
            <el-button
              type="primary"
              class="btn"
              style="height: 36px"
              @click="onCopy(form.external_contact.token)"
            >
              复制
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="EncodingAESKey">
          <div>
            <el-input
              v-model="form.external_contact.aes_key"
              disabled
              style="width: 600px; color: #595959"
            />
            <el-button
              type="primary"
              class="btn"
              style="height: 36px"
              @click="onCopy(form.external_contact.aes_key)"
            >
              复制
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </SpCardContent>

    <SpCardContent :title="`通讯录API授权设置`">
      <el-form
        ref="form"
        :model="form"
        label-width="200px"
      >
        <el-form-item label="AgentId">
          <el-input
            v-model="form.contacts.agent_id"
            style="width: 600px"
          />
        </el-form-item>
        <el-form-item label="Secret">
          <el-input
            v-model="form.contacts.secret"
            style="width: 600px"
          />

          <div class="tips">
            获取路径：（同上方 客户联系回调 设置的 Secret ）<br>

            1. 在
            <a
              href="https://work.weixin.qq.com/wework_admin/loginpage_wx?from=myhome"
              target="_blank"
            >企业微信管理后台</a>
            -「应用管理」-应用-下方的「自建应用」中找到云店小程序。<br>

            2.
            点击进入应用详情页，点击「Secret」后的「查看」按钮。该Secret会发送到当前登录的管理员账号的企业微信内，管理员在企业微信内复制获取，将获取到的Secret粘贴至此处。
          </div>
        </el-form-item>
        <!-- <el-form-item label="通讯录Token">
          <el-input
            v-model="form.contacts.token"
            style="width: 600px"
          />

          <div class="tips">
            <a
              href="https://work.weixin.qq.com/api/doc#90000/90135/90966"
              target="_blank"
            >通讯录Token</a>
          </div>
        </el-form-item>
        <el-form-item label="通讯录EncodingAESKey">
          <el-input
            v-model="form.contacts.aes_key"
            style="width: 600px"
          />

          <div class="tips">
            <a
              href="https://work.weixin.qq.com/api/doc#90000/90135/90966"
              target="_blank"
            >通讯录EncodingAESKey</a>
          </div>
        </el-form-item> -->
      </el-form>
    </SpCardContent>

    <SpGlobalFooter>
      <el-button
        type="primary"
        :loading="loading"
        @click="onSubmit"
      >
        保存设置
      </el-button>
    </SpGlobalFooter>
  </div>
</template>

<script>
import { getOpenworkwechat, setOpenworkwechat, getInitInfo } from '@/api/qwAuth'
export default {
  data () {
    return {
      loading: false,
      URL: '',
      form: {
        is_show: true,
        corpid: '',
        account_id: '',
        app: {
          appid: '',
          agent_id: '',
          secret: '',
          token: '',
          aes_key: ''
        },
        external_contact: {
          secret: '',
          token: '',
          aes_key: '',
          agent_id: ''
        },
        contacts: {
          secret: '',
          token: '',
          aes_key: '',
          agent_id: ''
        }
      }
    }
  },
  mounted () {
    this.getSetting()
  },
  methods: {
    // 保存设置数据
    async onSubmit () {
      this.loading = true
      const data = await setOpenworkwechat(this.form).catch(() => {
        this.loading = false
      })
      if (data) {
        this.loading = false
        this.$message({
          message: '保存成功',
          type: 'success',
          duration: 5 * 1000
        })
      }
    },
    // 获取设置数据
    async getSetting () {
      const data = await getOpenworkwechat()
      console.log('getSetting-data', data)
      if (data) {
        this.form = data
      }
      this.getInitInfo()
    },
    getInitInfo () {
      getInitInfo().then((res) => {
        console.log('getInitInfo-res', res)
        this.URL = res.external_contacts_callback
        this.form.external_contact.token = res.external_contacts_token
        this.form.external_contact.aes_key = res.external_contacts_aeskey
      })
    },
    onCopy (text = '') {
      this.$copyText(text).then(
        (res) => {
          return this.$message.success('复制成功')
        },
        (err) => {
          return this.$message.error('复制失败')
        }
      )
    }
  }
}
</script>
